import { Drawer } from '@silverfort/sf-components';
import { TIER_SCOPES } from '../TierConsts';
import Resources from './Resources';
import { useState } from 'react';
import InScopeBadge from '../Badge/InScopeBadge';
import OutScopeBadge from '../Badge/OutScopeBadge';

const SCOPE_DRAWER_DESCRIPTION = {
    [TIER_SCOPES.IN_SCOPE]:
        'Select resources to assign to this tier. Privileged accounts authenticating to resources in scope will be assigned to the same tier, unless authenticating to resources of a higher and more privileged tier.',
    [TIER_SCOPES.OUT_SCOPE]:
        'Select resources to exclude from this tier. Privileged accounts authenticating to resources out scope will be not be assigned the tier.'
};

const SCOPE_MAX_WIDTH = {
    [TIER_SCOPES.IN_SCOPE]: 'max-w-[728px]',
    [TIER_SCOPES.OUT_SCOPE]: 'max-w-[680px]'
};

const ResourcesDrawer = ({ tierPart, defaultSelected, open, scope, onClose, updateTierPartScope }) => {
    const [newTierPart, setNewTierPart] = useState({ ...tierPart });
    const [shouldDisableSave, setShouldDisableSave] = useState(true);

    const saveResources = () => {
        updateTierPartScope(newTierPart);
        onClose();
    };

    return (
        <Drawer
            footerActionTitle="Save"
            footerCloseTitle="Cancel"
            footerActionProps={{
                disabled: shouldDisableSave
            }}
            onAction={saveResources}
            onClose={onClose}
            variant="persistent"
            open={open}
            anchor="right"
            headerTitle={
                <div className="flex gap-2">
                    <div>Resources</div>
                    {scope === TIER_SCOPES.IN_SCOPE ? <InScopeBadge /> : <OutScopeBadge />}
                </div>
            }
            headerDescription={SCOPE_DRAWER_DESCRIPTION[scope]}
            className={SCOPE_MAX_WIDTH[scope]}>
            <Resources
                setShouldDisableSave={setShouldDisableSave}
                tierPart={tierPart}
                defaultSelected={defaultSelected}
                scope={scope}
                isEditMode={open}
                onChange={setNewTierPart}
            />
        </Drawer>
    );
};

export default ResourcesDrawer;
